<template>
<v-row>
  <!--dados dessa Edição-->
  <v-col cols="12" class="">
    <v-card class="px-3">
      <v-card-title>
        <v-icon left color="red">mdi-receipt-clock</v-icon>
        <span class="title">Dados dessa Edição</span>
      </v-card-title>   
      <v-card-text class="subtitle-1 font-weight-light">
        <v-row>  
          <v-col cols="12" sm="4">
            <search-box
                label="* Tipo do Evento"
                popup-label="Selecione o Tipo do Evento"
                :id.sync="value.idEventoTipo"
                :descricao.sync="value.descEventoTipo"
                :value="eventoTipo"
                :loader-fn="loaderEventoTipo"
                item-key="id"
                item-text="descricao"
                :rules="[
                      this.$validators.notNullOrUndefined
                  ]">
              <template v-slot:empty>
                <p class="ma-2">
                  Nenhuma EventoTipo encontrada
                </p>
              </template>
            </search-box>
          </v-col>  
          <v-col cols="12" sm="4">
            <search-box
                label="* Evento"
                popup-label="Selecione um Evento"
                :id.sync="value.idEvento"
                :descricao.sync="value.descEvento"
                :value="evento"
                :loader-fn="loaderEvento"
                item-key="id"
                item-text="descricao"
                :rules="[
                      this.$validators.notNullOrUndefined
                  ]">
              <template v-slot:empty>
                <p class="ma-2">
                  Nenhum Evento encontrado
                </p>
              </template>
            </search-box>
          </v-col>
          <v-col cols="12" md="4">
            <v-file-input
              dense
              accept=".jpg, .jpeg, .png"
              :label="'Escolha uma imagem de capa de até ' + this.tamanhoImg + 'MB'"
              v-model="value.imgCapa"
              :rules="[
                v => this.$validators.number.tamanhoMaxArquivo(v, this.tamanhoImg)
              ]"
              ></v-file-input>
          </v-col>
          <v-col cols="12" sm="4">
            <v-text-field label="* Data Inicio Insc."
                dense
                type="date"
                v-model="value.dtInicioInscricao"
                :rules="[
                    this.$validators.string.required,
                    v => this.$validators.string.lessThanOrEquals(v, 10)
                ]"/>
          </v-col>
          <v-col cols="12" sm="4">
            <v-text-field label="* Data Fim Insc."
                  dense
                  type="date"
                  v-model="value.dtFimInscricao"
                  :rules="[
                      this.$validators.string.required,
                      v => this.$validators.string.lessThanOrEquals(v, 10)
                  ]"/>
          </v-col>
          <v-col cols="12" sm="3">
            <lookup-dominio label="* Status"
              :disabled="isNovoCadastro"
              v-model="value.status"
              :type="lookups.status"
              :hidden-clear="false"/>
          </v-col>
          <v-col cols="12" sm="6">
            <lookup-dominio label="* Inscrição"
              v-model="value.tipoAcessoEvento"
              :radio="true"
              :type="lookups.tipoAcessoEvento"
              :hidden-clear="false"
              :rules="[
                  this.$validators.notNullOrUndefined
                ]"
            />
          </v-col>
          <v-col cols="12" sm="6" v-show="value.tipoAcessoEvento === 'P'">
            <v-text-field dense
              label="Valor Inscrição"
              prefix="R$"
              v-model="value.valorInscricao"
              v-money="moneyConfig"/>
          </v-col>          
        </v-row>
      </v-card-text>
    </v-card>
  </v-col>
  <!--dados da Localização-->
  <v-col cols="12" class="">
    <v-card class="px-3">
      <v-card-title>
        <v-icon left color="red">mdi-map-marker-radius</v-icon>
        <span class="title">Localização</span>
      </v-card-title>      
      <v-card-text class="subtitle-1 font-weight-light">
        <v-row>
          <v-col cols="12" sm="3">
            <v-text-field label="* CEP"
                          dense
                          v-mask="'########'"
                          :rules="[
                            this.$validators.string.required,
                            v => this.$validators.string.exactLength(v, 8),
                          ]"
                          v-model.trim="value.cep"/>
          </v-col>
          <v-col cols="12" sm="3">
            <v-text-field label="* Cidade"
                          dense
                          :rules="[
                            this.$validators.string.required,
                            v => this.$validators.string.greaterThanOrEquals(v, 1),
                            v => this.$validators.string.lessThanOrEquals(v, 100),
                        ]"
                        :value="value.cidade"/>
          </v-col>
          <v-col cols="12" sm="3">
            <lookup-dominio label="* Estado"
                            :hidden-clear="true"
                            :value="value.estado"
                            :type="lookups.estado"
                            :rules="[
                                this.$validators.string.required
                            ]"/>
          </v-col>    
          <v-col cols="12" sm="3">
            <v-text-field label="* Bairro"
                          dense
                          :rules="[
                            this.$validators.string.required,
                            v => this.$validators.string.greaterThanOrEquals(v, 1),
                            v => this.$validators.string.lessThanOrEquals(v, 100),
                        ]"
                        v-model.trim="value.bairro"/>
          </v-col>
          <v-col cols="12" sm="6">
            <v-textarea v-if="$vuetify.breakpoint.mobile"
                        dense
                        rows="3"
                        label="* Endereço"
                        :rules="[
                            this.$validators.string.required,
                            v => this.$validators.string.greaterThanOrEquals(v, 1),
                            v => this.$validators.string.lessThanOrEquals(v, 100),
                        ]"
                        v-model.trim="value.endereco"/>
            <v-text-field v-else label="* Endereço"
                          dense
                          :rules="[
                            this.$validators.string.required,
                            v => this.$validators.string.greaterThanOrEquals(v, 1),
                            v => this.$validators.string.lessThanOrEquals(v, 100),
                        ]"
                        v-model.trim="value.endereco"/>
          </v-col>
          <v-col cols="12" sm="6">
            <v-textarea v-if="$vuetify.breakpoint.mobile"
                        dense
                        rows="3"
                        label="Complemento"
                        :rules="[
                            v => this.$validators.string.greaterThanOrEquals(v, 1),
                            v => this.$validators.string.lessThanOrEquals(v, 100),
                        ]"
                        v-model.trim="value.complemento"/>
            <v-text-field v-else label="Complemento"
                          dense
                          :rules="[
                              v => this.$validators.string.greaterThanOrEquals(v, 1),
                            v => this.$validators.string.lessThanOrEquals(v, 100),
                        ]"
                        v-model.trim="value.complemento"/>
          </v-col>
        </v-row>            
      </v-card-text>
    </v-card>
  </v-col>
  <!--regras dos participantes-->
  <v-col cols="12" class="">
    <v-card class="px-3">
      <v-card-title>
        <v-icon left color="red">mdi-account</v-icon>
        <span class="title">Regras dos participantes</span>
      </v-card-title>      
      <v-card-text class="subtitle-1 font-weight-light">
        <v-row>
          <v-col cols="12" sm="6">
            <v-radio-group v-model="value.publicoAlvo" row 
              dense
              :rules="[
                this.$validators.string.required,
              ]">
              <v-radio color="#efc00f"
                value="TOD">
                <template v-slot:label>
                  Todos
                </template>
              </v-radio>
              <v-radio color="#efc00f"
                value="FOR">
                <template v-slot:label>
                  Fornecedor
                </template>
              </v-radio>
              <v-radio color="#efc00f"
                value="COM">
                <template v-slot:label>
                  Comprador
                </template>
              </v-radio>
            </v-radio-group>
          </v-col>   
          <v-col cols="12" sm="6">
            <v-text-field label="* Nº Máximo de Inscrições"
                          dense
                          :rules="[
                            this.$validators.string.required,
                        ]"
                        v-model.trim="value.numMaxInscritos"/>
          </v-col>
          <v-col cols="12"> 
            <search-box-multiple
                label="* Estados Permitidos: TODOS"
                class="search-box-cursos"
                popup-label="Selecione os Estados Permitidos"
                v-model="value.estadosPermitidos"
                :loader-fn="loaderEstados"
                item-key="key"
                item-text="valor">
              <template v-slot:selection="{item}" >
                <div @click.stop class="curso-chip v-chip">
                  <div class="item-description">{{item.valor}}</div>
                  <div class="remove-button" @click="removeEstado(item)">
                    <v-btn x-small icon class="ma-0 pa-0">
                      <v-icon>mdi-close-circle</v-icon>
                    </v-btn>
                  </div>
                </div>
              </template>
              <template v-slot:empty>
                <p class="ma-2">
                  Nenhum Estado encontrado
                </p>
              </template>
            </search-box-multiple>
          </v-col> 
          <v-col cols="12" md="6">
            <search-box-multiple
                label="Portes Permitidos: TODOS"
                class="search-box-cursos"
                popup-label="Selecione os Portes Permitidos"
                v-model="value.portesPermitidos"
                :loader-fn="loaderPorte"
                item-key="id"
                item-text="descricao">
              <template v-slot:selection="{item}" >
                <div @click.stop class="curso-chip v-chip">
                  <div class="item-description">{{item.descricao}}</div>
                  <div class="remove-button" @click="removePorte(item)">
                    <v-btn x-small icon class="ma-0 pa-0">
                      <v-icon>mdi-close-circle</v-icon>
                    </v-btn>
                  </div>
                </div>
              </template>
              <template v-slot:empty>
                <p class="ma-2">
                  Nenhum Porte encontrado
                </p>
              </template>
            </search-box-multiple>
          </v-col>
          <v-col cols="12" md="6">
            <search-box-multiple
                label="Atividades Econômicas Permitidas: TODOS"
                class="search-box-cursos"
                popup-label="Selecione as Atividades Econômicas Permitidas"
                v-model="value.atividadesEconomicasPermitidas"
                :loader-fn="loaderAtividadeEconomica"
                item-key="id"
                item-text="descricao">
              <template v-slot:selection="{item}" >
                <div @click.stop class="curso-chip v-chip">
                  <div class="item-description">{{item.descricao}}</div>
                  <div class="remove-button" @click="removeAtividadeEconomica(item)">
                    <v-btn x-small icon class="ma-0 pa-0">
                      <v-icon>mdi-close-circle</v-icon>
                    </v-btn>
                  </div>
                </div>
              </template>
              <template v-slot:empty>
                <p class="ma-2">
                  Nenhum Atividade Econômica encontrada
                </p>
              </template>
            </search-box-multiple>
          </v-col>
        </v-row>            
      </v-card-text>
    </v-card>
  </v-col>
  <!--Cronograma-->
  <v-col cols="12" class="">
    <v-card class="px-3">
      <v-card-title>
        <v-row>
          <v-col cols="12" sm="10">
            <v-icon left color="red">mdi-calendar</v-icon>
            <span class="title">Cronograma</span>
          </v-col>
          <v-col cols="12" sm="2" class="d-flex justify-end">
            <v-btn text elevation="0" small @click="add()">
              Adicionar <v-icon>mdi-plus</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-title>      
      <v-card-text class="subtitle-1 font-weight-light">
        <v-row class="separador" v-for="(item, index) of value.cronograma" :key="index">
          <v-col cols="12" sm="4">
            <v-text-field label="* Data"
                  dense
                  type="date"
                  v-model="item.data"
                  :rules="[
                      validators.string.required,
                      v => validators.string.lessThanOrEquals(v, 10)
                  ]"/>      
          </v-col>
          <v-col cols="12" sm="3">
            <v-text-field label="* Hora Inicio"
                  dense
                  type="time"
                  v-model="item.horaInicio"
                  :rules="[
                      validators.string.required,
                      v => validators.string.lessThanOrEquals(v, 10)
                  ]"/>      
          </v-col>
          <v-col cols="12" sm="3">
            <v-text-field label="* Hora Fim"
                  dense
                  type="time"
                  v-model="item.horaFim"
                  :rules="[
                      validators.string.required,
                      v => validators.string.lessThanOrEquals(v, 10)
                  ]"/>      
          </v-col>
          <v-col cols="12" sm="2" class="d-flex justify-end">
            <v-btn text elevation="0" small @click="remove(index)">
              remover <v-icon>mdi-minus</v-icon>
            </v-btn>
          </v-col>
          <v-col cols="12" sm="12">
            <v-textarea
              dense
              rows="3"
              label="* O que vai rolar"
              :rules="[
                validators.string.required,
                v => validators.string.greaterThanOrEquals(v, 1),
                v => validators.string.lessThanOrEquals(v, 800)
              ]"
              v-model.trim="item.descricao"/>         
          </v-col>
        </v-row>            
      </v-card-text>
    </v-card>
  </v-col>    
  <!--Mais Informações-->
  <v-col cols="12" class="">
    <v-card class="px-3">
      <v-card-title>
        <v-icon left color="red">mdi-plus</v-icon>
        <span class="title">Mais Informações</span>
      </v-card-title>      
      <v-card-text class="subtitle-1 font-weight-light">
        <v-row>
          <v-col cols="12" sm="12">
            <v-textarea
              dense
              rows="6"
              label="* Detalhes sobre essa edição"
              :rules="[
                this.$validators.string.required,
                v => this.$validators.string.greaterThanOrEquals(v, 1),
                v => this.$validators.string.lessThanOrEquals(v, 800)
              ]"
              v-model.trim="value.maisInfo"/>         
          </v-col>
        </v-row>            
      </v-card-text>
    </v-card>
  </v-col>  
</v-row>
</template>

<script>
import LookupDominio from "../common/LookupDominio";
import SearchBox from "../common/SearchBox";
import CardPersonalizado from "../common/CardPersonalizado";
import SearchBoxMultiple from "../common/SearchBoxMultiple";
import {findAll as findAllEvento} from "../../../api/evento";
import {findAll as findAllEventoTipo} from "../../../api/eventoTipo";
import {findAll as findAllPorte} from "../../../api/porte";
import {findAll as findAllAtividadeEconomica} from "../../../api/atividadeEconomica";
import {ItemDeDominio, findFormItemDominio} from "../../../api/itemsDominio";
import {buscaEnderecoViaCep} from '../../../api/correios';

export default {
  name: "EventoEdicaoForm",
  components: {LookupDominio, SearchBox, CardPersonalizado, SearchBoxMultiple},
  props: {
    value: {
      type: Object
    }
  },
  data () {
    return {
      lookups: {
        status: ItemDeDominio.STATUS_PADRAO,
        estado: ItemDeDominio.COMBO_ESTADO,
        tipoAcessoEvento: ItemDeDominio.TIPO_ACESSO_EVENTO
      },
      tamanhoImg: 1,
    }
  },
  watch: {
    'value.cep': {
      handler(newValue, oldValue) {
        if (newValue !== oldValue){
          this.buscaEndereco();
        }
      }
    }
  },
  computed: {
    validators(){
      return this.$validators;
    },
    isNovoCadastro(){
      return !(this.value && 
             this.value.id !== null && 
             this.value.id !== undefined &&
             parseInt(this.value.id) > 0);
    },
    evento() {
      if(this.value.idEvento == null) return null;
      return {
        id: this.value.idEvento,
        descricao: this.value.descEvento
      }
    },
    eventoTipo() {
      if(this.value.idEventoTipo == null) return null;
      return {
        id: this.value.idEventoTipo,
        descricao: this.value.descEventoTipo
      }
    },
    fornecedorPode() {
      return this.value.publicoAlvo === 'FOR' || this.value.publicoAlvo === 'TOD';
    },
    compradorPode() {
      return this.value.publicoAlvo === 'COM' || this.value.publicoAlvo === 'TOD';
    },
  },
  methods: {
    loaderEvento(page, search) {
      return findAllEvento(page, {
        descricao: search
      })
    },
    loaderEventoTipo(page, search) {
      return findAllEventoTipo(page, {
        descricao: search
      })
    }, 
    loaderPorte(page, search) {
      return findAllPorte(page, {
        nome: search
      })
    },
    loaderAtividadeEconomica(page, search) {
      return findAllAtividadeEconomica(page, {
        nome: search
      })
    },    
    loaderEstados(page, search){
      const estados = findFormItemDominio(1,ItemDeDominio.COMBO_ESTADO);
      return estados;
    },
    removeEstado(item) {
      this.value.estadosPermitidos = this.value.estadosPermitidos.filter(v => v.key !== item.key);
    },
    removePorte(item) {
      this.value.portesPermitidos = this.value.portesPermitidos.filter(v => v.id !== item.id);
    },
    removeAtividadeEconomica(item) {
      this.value.atividadesEconomicasPermitidas = this.value.atividadesEconomicasPermitidas.filter(v => v.id !== item.id);
    },
    async buscaEndereco(){
      if (this.value.cep !== "" && this.value.cep.length === 8){
        let endereco = await buscaEnderecoViaCep(this.value.cep);
        this.value.cidade = endereco.localidade;
        this.value.estado = endereco.uf;
        this.value.bairro = endereco.bairro;
        this.value.endereco = endereco.logradouro;
      }
    },
    add() {
      this.value.cronograma.push({
        id: null,
        data: null,
        horaInicio: null,
        horaFim: null,
        descricao: null,
      });
    },
    remove(index) {
      this.value.cronograma.splice(index, 1);
    },
  },
  mounted() {
    if (this.isNovoCadastro){
      this.value.status = 'A';
    }
  }
}
</script>

<style scoped lang="scss">
.separador {
  border: 1px dashed rgb(37, 37, 37);
  margin-bottom: 5px;
  padding-top: 5px;
}
.curso-chip {
  padding-right: 0;
  cursor: initial;
  background-color: rgba(0,0,0,0.1);
  height: 32px;
  border-radius: 16px;
  border: 1px solid #dedede;
  display: flex;
  justify-content: center;
  align-items: center;

  .item-description {
    min-width: 150px;
    max-width: 200px;
    text-overflow: ellipsis;
    overflow: hidden;
    padding-right: 5px;
  }
  .remove-button {
    height: 32px;
    cursor: pointer;
    background-color: rgba(0,0,0,0.2);
    border-left: 2px solid #dedede;
    padding: 5px 8px !important;
    transition: background-color 0.5s ease 0s;
    &:hover {
      background-color: rgba(0,0,0,0.3);
    }
  }
}
</style>